import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import {Form} from "react-bootstrap";
import Style from "../Style.module.css";
import * as AssetsService from "../../api/AssetsService"
import {useTranslation} from "react-i18next";

export default function MyCardsNewDeck(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'myCardsNewDeck' });
    const [deckName, setDeckName] = useState(t('defaultDeckName'))
    const [withDefaultText, setWithDefaultText] = useState(false)
    const [withDefaultEnText, setWithDefaultEnText] = useState(false)
    const [saveEnabled, setSaveEnabled] = useState(true)

    function selectDefaultText() {
        setWithDefaultText(true)
        setWithDefaultEnText(false)
    }

    function selectDefaultEnText() {
        setWithDefaultText(false)
        setWithDefaultEnText(true)
    }

    function unselectDefaultText() {
        setWithDefaultText(false)
        setWithDefaultEnText(false)
    }

    function ResolvePlayerName(evt) {
        setDeckName(evt.target.value)
        if (evt.target.value.trim().length === 0) {
            setSaveEnabled(false)
        } else {
            setSaveEnabled(true)
        }
    }

    function saveNewCustomDeck() {
        setSaveEnabled(false)
        AssetsService.createNewCustomDeck(
            deckName,
            withDefaultText,
            withDefaultEnText,
            () => {
                props.setCurrentView("my_cards_menu")
            },
            () => {
                window.alert(t('error'))
                setSaveEnabled(true)
            }
        )
    }


    return <div className={cabinetStyle.mainPageContainer}>
        <div className={`${cabinetStyle.commonTile} ${cabinetStyle.profilePage}`}>
            <Form>
                <Form.Group className={cabinetStyle.profileElement}>
                    <Form.Label className={Style.bodyBaseText}>{t('deckName')}</Form.Label>
                    <Form.Control
                        id={"deck_name"}
                        style={{
                            marginBottom: "24px"
                        }}
                        value={deckName}
                        as="input"
                        onChange={e => ResolvePlayerName(e)}
                    />
                    <Form.Label className={Style.bodyBaseText}>{t('create')}</Form.Label>
                    <div>
                        <Form.Check
                            style={{
                                marginBottom: "24px"
                            }}
                            checked={!withDefaultText && !withDefaultEnText}
                            type="radio"
                            label={t('emptyCards')}
                            onChange={unselectDefaultText}
                        />
                        <Form.Check
                            style={{
                                marginBottom: "24px"
                            }}
                            checked={withDefaultText}
                            type="radio"
                            label={t('baseDeckUa')}
                            onChange={selectDefaultText}
                        />
                        <Form.Check
                            style={{
                                marginBottom: "24px"
                            }}
                            checked={withDefaultEnText}
                            type="radio"
                            label={t('baseDeckEN')}
                            onChange={selectDefaultEnText}
                        />
                    </div>

                </Form.Group>
            </Form>
            <br/>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <button className={`${cabinetStyle.confirmCreateNewGame} ${cabinetStyle.sideBarText}`}
                        id={"saveButton"}
                        onClick={saveNewCustomDeck}
                        disabled={!saveEnabled}>
                    <div>{t('createButton')}</div>
                </button>
            </div>

        </div>
    </div>
}